/* OG Variant Fix - Prestige
   - Evita auto-switch al load
   - Permette click su variante già selezionata
   - Non forza scroll pagina
*/
(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    // flag “utente ha davvero interagito”
    let userHasInteracted = false;
    window.addEventListener(
      "pointerdown",
      () => {
        userHasInteracted = true;
      },
      { once: true, capture: true }
    );

    // cache varianti -> JSON
    const variantCache = new Map();

    async function fetchVariantJson(variantId) {
      if (!variantId) return null;
      if (variantCache.has(variantId)) return variantCache.get(variantId);
      try {
        const res = await fetch(`/variants/${variantId}.js`, { credentials: "same-origin" });
        if (!res.ok) return null;
        const json = await res.json();
        variantCache.set(variantId, json);
        return json;
      } catch (e) {
        return null;
      }
    }

    function getVariantIdFromForm(form) {
      if (!form) return null;
      const idInput = form.querySelector('input[name="id"]');
      return idInput ? idInput.value : null;
    }

    function findProductRoot(fromEl) {
      // prova a stare “vicini” al prodotto interessato
      return (
        fromEl.closest("product-info") ||
        fromEl.closest(".product") ||
        fromEl.closest('[id^="shopify-section-"]') ||
        document
      );
    }

    function findGallery(root) {
      // Prestige di solito ha product-gallery come custom element
      return root.querySelector("product-gallery") || root.querySelector('[data-product-gallery]') || null;
    }

    function clickMediaInGallery(gallery, mediaId) {
      if (!gallery || !mediaId) return false;

      // 1) se esiste un carousel con .select
      try {
        if (gallery.carousel && typeof gallery.carousel.select === "function") {
          const el = gallery.querySelector(`[data-media-id="${mediaId}"]`);
          if (el) {
            // posizione: spesso è 1-based nei data, qui evitiamo calcoli e proviamo via index DOM
            const items = Array.from(gallery.querySelectorAll("[data-media-id]"));
            const idx = items.findIndex((x) => x.getAttribute("data-media-id") === String(mediaId));
            if (idx >= 0) {
              gallery.carousel.select(idx, { instant: true });
              return true;
            }
          }
        }
      } catch (e) {}

      // 2) prova a cliccare la thumb/trigger (evita scroll pagina)
      const trigger =
        gallery.querySelector(`[data-media-id="${mediaId}"] button`) ||
        gallery.querySelector(`[data-media-id="${mediaId}"] a`) ||
        gallery.querySelector(`[data-media-id="${mediaId}"]`);

      if (trigger && typeof trigger.click === "function") {
        trigger.click();
        return true;
      }

      return false;
    }

    async function syncGalleryToCurrentVariant(form, sourceEl) {
      const variantId = getVariantIdFromForm(form);
      const root = findProductRoot(sourceEl || form);
      const gallery = findGallery(root);

      // Se non c’è gallery, esci
      if (!gallery) return;

      const v = await fetchVariantJson(variantId);
      const featuredMediaId = v && v.featured_media && v.featured_media.id ? v.featured_media.id : null;

      if (!featuredMediaId) return;

      clickMediaInGallery(gallery, featuredMediaId);
    }

    // Listener: cattura click anche se la variante è già selezionata (non scatta "change")
    document.addEventListener(
      "click",
      async (e) => {
        const target = e.target;
        if (!target) return;

        // prendi controlli varianti: label/radio/select
        const control =
          target.closest('label') ||
          target.closest('input[type="radio"][name*="option"]') ||
          target.closest('select[name*="option"]');

        if (!control) return;

        // non fare nulla se non c’è stata interazione reale (protezione anti auto)
        // qui l’utente ha cliccato, quindi userHasInteracted sarà true
        if (!userHasInteracted) return;

        const root = findProductRoot(control);
        const form =
          root.querySelector('form[id^="product-form"]') ||
          document.querySelector('form[id^="product-form"]');

        if (!form) return;

        // aspetta un tick: Shopify/Prestige aggiorna input[name=id] dopo il click
        setTimeout(() => {
          syncGalleryToCurrentVariant(form, control);
        }, 0);
      },
      true
    );

    // Listener: quando cambia davvero variante (seconda, terza, ecc)
    document.addEventListener(
      "change",
      (e) => {
        const t = e.target;
        if (!t) return;

        if (
          t.matches('input[type="radio"][name*="option"]') ||
          t.matches('select[name*="option"]') ||
          t.matches('input[name="id"]')
        ) {
          const root = findProductRoot(t);
          const form =
            root.querySelector('form[id^="product-form"]') ||
            document.querySelector('form[id^="product-form"]');

          if (!form) return;

          // qui è già un’azione dell’utente
          syncGalleryToCurrentVariant(form, t);
        }
      },
      true
    );
  }
})();
